import { c as _c } from "react-compiler-runtime";
import { Text } from "@/components/primitives";
type HintMessageProps = {
  text: string;
  id: string;
};
export default function HintMessage(t0) {
  const $ = _c(5);
  const {
    text,
    id
  } = t0;
  let t1;
  if ($[0] !== text) {
    t1 = <Text display="block" text={text} variant="caption" />;
    $[0] = text;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== id || $[3] !== t1) {
    t2 = <div className="flex items-center gap-1" id={id}>{t1}</div>;
    $[2] = id;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}